import { CsvConfigConsts } from './csv-config-consts';
import { Options } from './csv-options.interface';
import { ConfigDefaults } from './default-config';
import { isFloat, objectAssign } from './util';

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export class CsvHandler {
  private readonly data: any[];
  private readonly _options: Options;

  constructor(DataJSON: any, filename: string, options?: any) {
    const config = options || {};

    this.data = typeof DataJSON !== 'object' ? JSON.parse(DataJSON) : DataJSON;

    this._options = objectAssign({}, ConfigDefaults, config);

    if (this._options.filename) {
      this._options.filename = filename;
    }
  }

  /**
   * Generate and Download Csv
   */
  generateCsv() {
    let csv = '';
    if (this._options.useBom) {
      csv += CsvConfigConsts.BOM;
    }
    if (this._options.showTitle) {
      csv += this._options.title + '\r\n\n';
    }
    csv += this.getHeaders();
    csv += this.getBody();
    if (csv == '') {
      return;
    } // Invalid data;

    return csv;
  }

  /**
   * Create Headers
   */
  getHeaders() {
    let headers = '';
    if (this._options.headers.length > 0) {
      let row = '';
      for (const column of this._options.headers) {
        row += column + this._options.fieldSeparator;
      }

      row = row.slice(0, -1);
      headers += row + CsvConfigConsts.EOL;
    }

    return headers;
  }

  /**
   * Create Body
   */
  getBody() {
    let body = '';
    for (const element of this.data) {
      let row = '';
      for (const index in element) {
        row += this.formatData(element[index]) + this._options.fieldSeparator;
      }

      row = row.slice(0, -1);
      body += row + CsvConfigConsts.EOL;
    }
    return body;
  }

  /**
   * Format Data
   * @param {any} data
   */
  formatData(data: any) {
    if (this._options.decimalSeparator === 'locale' && isFloat(data)) {
      return data.toLocaleString();
    }

    if (this._options.decimalSeparator !== '.' && isFloat(data)) {
      return data.toString().replace('.', this._options.decimalSeparator);
    }

    if (typeof data === 'string') {
      data = data.replace(/"/g, '""');
      if (this._options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
        data = this._options.quoteStrings + data + this._options.quoteStrings;
      }
      return data;
    }

    if (typeof data === 'undefined') {
      return '';
    }

    if (data === null) {
      return '';
    }

    if (typeof data === 'boolean') {
      return data ? 'TRUE' : 'FALSE';
    }

    return data;
  }
}
